<template>
  <div class="hld-home">
    <div class="content">
      <!-- <div class="logo-section">
        <div class="logos">
          <div class="logo-item">优才中心</div>
          <div class="logo-item">锦鲤升学</div>
        </div>
      </div>
      <div class="quote">""</div>
      <h2>霍兰德兴趣测评</h2>
      <div class="image-section">
        <div class="paper-plane"></div>
      </div> -->
      <div class="button-section">
        <button class="btn primary-btn" @click="goToTest">进入测评</button>
        <button class="btn secondary-btn" @click="goToResult">
          查看测评结果
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HLDHome",
  methods: {
    goBack() {
      this.$router.push("/");
    },
    goToTest() {
      this.$router.push("/hld-action");
    },
    goToResult() {
      const openid =
        localStorage.getItem("openId") || localStorage.getItem("openid") || "";
      if (openid) {
        this.$router.push({
          path: "/hld-result",
          query: { openid: openid, wjId: "2" },
        });
      } else {
        this.$message.warning("暂无微信登录信息，请先完成登录");
      }
    },
  },
};
</script>

<style scoped>
.hld-home {
  height: 100vh;
  background-image: url("../assets/images/hld-home-bg.png");
  background-size: cover;
  position: relative;
  overflow: hidden;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: absolute;
  top: 20px;
  left: 20px;
  right: 20px;
}

.back-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  padding: 0;
}

.header h1 {
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.more-options {
  display: flex;
  gap: 5px;
}

.dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #999;
}

.content {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.logo-section {
  position: absolute;
  top: 80px;
  left: 50%;
  transform: translateX(-50%);
}

.logos {
  display: flex;
  align-items: center;
  gap: 20px;
}

.logo-item {
  font-size: 14px;
  color: #666;
}

.quote {
  position: absolute;
  top: 20%;
  left: 50%;
  transform: translateX(-50%);
  font-size: 48px;
  color: #999;
  opacity: 0.5;
}

.content h2 {
  position: absolute;
  top: 28%;
  left: 50%;
  transform: translateX(-50%);
  font-size: 28px;
  font-weight: 700;
  color: #333;
  position: relative;
  text-align: center;
}

.content h2::after {
  content: ">";
  position: absolute;
  right: -30px;
  top: 0;
  font-size: 24px;
  color: #66b2ff;
}

.image-section {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 200px;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.paper-plane {
  width: 120px;
  height: 120px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  position: relative;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.paper-plane::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80px;
  height: 60px;
  background: #fff;
  clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.button-section {
  position: absolute;
  bottom: 60px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 100%;
  max-width: 300px;
}

.btn {
  width: 100%;
  padding: 15px;
  border: none;
  border-radius: 25px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.primary-btn {
  background: linear-gradient(135deg, #b4c1fd 0%, #7e94f9 100%);
  color: #fff;
  box-shadow: 0 4px 12px rgba(102, 178, 255, 0.3);
}

.primary-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(102, 178, 255, 0.4);
}

.secondary-btn {
  background: #fff;
  color: #333;
  border: 1px solid #e0e0e0;
}

.secondary-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
</style>